// AiConnectionStore.ts

import { makeAutoObservable, runInAction } from "mobx"
import { aiBridge } from "../services/ai-adapter/bridge"
import { AiRequest } from "../services/ai-adapter/protocol"

export class AiConnectionStore {
  loading = false
  error: string | null = null
  private bridge = aiBridge

  constructor() {
    makeAutoObservable(this)
  }

  async ask(
    action: AiRequest["action"],
    userMessage: string,
    context: AiRequest["context"],
    utility: AiRequest["utility"],
  ) {
    runInAction(() => {
      this.loading = true
      this.error = null
    })

    try {
      const result = await this.bridge.send(action, userMessage, context, utility)
      return result
    } catch (e: unknown) {
      runInAction(() => {
        this.error = e instanceof Error ? e.message : String(e)
      })
      throw e
    } finally {
      runInAction(() => {
        this.loading = false
      })
    }
  }
}
